import { FormPageButton } from "../components/FormPageButton";
import { Link } from "react-router-dom";
import { TrSpace } from "../components/TrSpace";

export const OrderCompleted = () => {
    return (
        <div className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>注文が完了しました</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table>
                            <tbody>
                                <tr><td><p className="text-sm md:text-base px-10">購入者のメールアドレスに注文完了メールが届きます。</p></td></tr>
                                <tr><td><p className="text-sm md:text-base px-10">注文完了メールに記載されている振り込み先に期日までに振り込みを完了させてください。</p></td></tr>
                                <tr><td><p className="text-sm md:text-base px-10">振り込みが終了しましたら、本が到着するのを楽しみにお待ちください。</p></td></tr>
                                <TrSpace/>
                                <TrSpace/>
                            </tbody>
                        </table>
                        <Link to="/">
                            <FormPageButton text="ホームへ戻る"/>
                        </Link>
                    </div>
                </main>
        </div>
    );
};